import React, { useEffect } from "react";
import { useRouter } from "next/router";
import sal from "sal.js";
// import CourseData from "../../../data/course-details/courseData.json";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";

import MobileMenu from "@/components/Header/MobileMenu";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import Cart from "@/components/Header/Offcanvas/Cart";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
import CourseHead from "@/components/Course-Details/Course-Sections/course-head";
import CourseDetailsOne from "@/components/Course-Details/CourseDetails-One";
import PageHead from "@/pages/Head";
import CourseActionBottom from "@/components/Course-Details/Course-Sections/Course-Action-Bottom";
import SimilarCourses from "@/components/Course-Details/Course-Sections/SimilarCourses";
// import { readFile } from 'fs/promises'
// import { serialize } from 'next-mdx-remote/serialize'
import CPStaticContent from '../../../models/CPStaticContent.js'
import Instagram from "@/components/Instagram/Instagram";
import GoogleAdLarge from "@/components/Ads/GoogleAdLarge.js";

const SingleCourse = (course) => {
  const router = useRouter();
  const courseId = router.query.courseId;
  // console.log(post)
  // const courseInfo = post.info
  const mdxSource = course.content
  // const getCourses = post.list
  const checkMatch = course.info

  useEffect(() => {
    if (courseId && checkMatch === undefined) {
      router.push("/courses");
    }

    sal({
      threshold: 0.01,
      once: true,
    });
  }, [checkMatch, router]);

  return (
    <>
      <PageHead post={course.info} />
      <Provider store={Store}>
        <Context>
          <MobileMenu />
          <HeaderStyleTen headerSticky="" headerType={true} />
          <Cart />

          <div className="rbt-breadcrumb-default rbt-breadcrumb-style-3">
            <CourseHead
              checkMatch={checkMatch !== undefined ? checkMatch : ""}
            />
          </div>

          <div className="rbt-course-details-area ptb--60">
            <div className="container">
              <div className="row g-5">
                <CourseDetailsOne
                  checkMatchCourses={checkMatch !== undefined ? checkMatch : ""}
                  courseContent={mdxSource}
                />
              </div>
            </div>
          </div>

          {/* <CourseActionBottom
            checkMatchCourses={checkMatch !== undefined ? checkMatch : ""}
          /> */}

          <div className="rbt-related-course-area bg-color-white pt--60 rbt-section-gapBottom">
            <SimilarCourses
              checkMatchCourses={
                course !== undefined ? course.similar : ""
              }
            />
          </div>

          <Instagram />

          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default SingleCourse;

export async function getStaticProps(context) {
  const stContent = new CPStaticContent("courses")
  await stContent.fetchContent()
  return await stContent.getItemProps(context.params.postId)
}

export async function getStaticPaths(context) {
  const stContent = new CPStaticContent("courses")
  await stContent.fetchContent()
  const paths = await stContent.getPaths()
  return { paths, fallback: false }
}